<template>
  <div style="width: 100%">
    <div class="gonggao">
      <ul class="gonggao_ul">
        <li :class="li_id == 0 ? 'li_hover' : ''" @mousemove="changeBJ(0)">
          公示公告
        </li>
        <li :class="li_id == 1 ? 'li_hover' : ''" @mousemove="changeBJ(1)">
          土地信息
        </li>
      </ul>
      <div
        class="xianwenList"
        style="padding: 0 20px; width: 98.5%; position: relative"
        v-if="li_id == 0">
        <span style="font-size: 28px; font-weight: 600">{{
          list0.keyword
        }}</span>
        <div style="height: 77%; overflow: hidden" v-html="list0.content"></div>
        <router-link
          style="
            font-size: 24px;
            z-index: 99;
            position: absolute;
            right: 50px;
            bottom: 0;
          "
          :to="{
            name: '公示公告详情',
            query: { id: list0 && list0.id ? list0.id : '' },
          }"
          >{{ list0 && list0.id ? '【详情】' : '' }}</router-link
        >
        <!-- <li v-for="(item, index) in list0" :key="index">
                    <router-link :to="{ name: '新闻中心详情', query: { id: item.id } }">
                        <span>{{ item.title }}</span>
                        <span>[{{ item.logintime }}]</span>
                    </router-link>
                </li> -->
      </div>
      <ul class="xianwenList" v-if="li_id == 1">
        <li v-for="(item, index) in list1" :key="index">
          <router-link :to="{ name: '土地信息详情', query: { id: item.id } }">
            <span>{{ item.title }}</span>
            <span>[{{ item.logintime }}]</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      li_id: 0,
      list0: [],
      list1: [],
    }
  },
  created() {
    // 中心动态数据
    let url0 = 'gongshigonggao'
    // console.log(this.ajax_url(url0));
    this.list0 = this.ajax_url(url0).data
    // 业界新闻数据
    let url1 = 'tudixinxi'
    // console.log(this.ajax_url(url1));
    this.list1 = this.ajax_url(url1).data
  },
  methods: {
    changeBJ(e) {
      this.li_id = e
    },
  },
}
</script>

<style scoped>
ul {
  margin: 0;
  padding: 0;
}

.gonggao {
  margin-top: 20px;
  flex: 1;
  height: 530px;
  /* background-color: red; */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: white;
}

.gonggao_ul {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  /* justify-content: space-around; */
  align-items: center;
  border-bottom: 2px solid #dbdbdb;
  padding: 0;
  margin: 0;
  border-bottom: 3px solid #2187ff;
}

.gonggao_ul > li {
  list-style: inside none;
  /* width: auto; */
  /* height: 66px; */
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 66px;
  padding: 0 10px;
  /* border-bottom: 3px solid #2187FF; */
  cursor: pointer;
  padding: 0 25px;
}

.gonggao_ul .li_hover {
  /* font-weight: bold; */
  color: #fff;
  background-color: #2187ff;
}

.xianwenList {
  flex: 1;
  /* padding: 20px 36px 0 54px;
  width: 100%;
  height: 365px; */
  overflow: hidden;
  padding: 20px;
  width: 100%;
  margin: 0;
}

.xianwenList > li {
  width: 98%;
  /* height: 47px; */
  line-height: 23px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.xianwenList > li > a {
  width: 100%;
  padding-bottom: 24px;
  display: flex;
  flex-flow: row nowrap;
  /* justify-content: space-between; */
  height: 23px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 23px;
  overflow: hidden;
  justify-content: space-between;
}

.xianwenList > li > a > span:first-child {
  padding-left: 22px;
  width: 800px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  background: url('../../../assets/img/i.png') no-repeat left center;
}
</style>
